import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { LoginUser, reset } from "../features/authSlice";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  InputGroup,
} from "react-bootstrap";
import logo from "../logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isError, isSuccess, isLoading } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (user || isSuccess) {
      navigate("/dashboard");
    }
    dispatch(reset());
  }, [user, isSuccess, dispatch, navigate]);

  const Auth = (e) => {
    e.preventDefault();
    dispatch(LoginUser({ email, password }));
  };

  return (
    <Container fluid className="d-flex flex-column min-vh-100">
      {/* Header */}
      <header className="bg-light py-3 shadow-sm header-well">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} className="d-flex align-items-center">
              <img
                src={logo}
                alt="Logo"
                width={40}
                height={45}
                className="me-2"
              />
              <strong className="fs-2">Cassava Super</strong>
            </Col>
          </Row>
        </Container>
      </header>

      {/* Form Login */}
      <Container className="d-flex flex-grow-1 align-items-center justify-content-center ">
        <Row className="w-100">
          <Col
            xs={12}
            md={10}
            lg={4}
            className="mx-auto p-4 shadow rounded bg-white form"
          >
            <h2 className="text-center mb-4">
              <strong>Selamat Datang</strong>
            </h2>
            {isError && (
              <Alert variant="danger">
                Email atau Password yang Anda masukkan tidak sesuai.
              </Alert>
            )}
            <Form onSubmit={Auth}>
              <Form.Group className="mb-3" controlId="InputEmail1">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="InputPassword1">
                <Form.Label>Password</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <Button
                    variant="secondary"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <IoEyeOffOutline size={20} />
                    ) : (
                      <IoEyeOutline size={20} />
                    )}
                  </Button>
                </InputGroup>
              </Form.Group>

              <Button type="submit" variant="primary" className="w-100">
                {isLoading ? "Loading..." : "Login"}
              </Button>

              <div className="text-center mt-3">
                <Link to="/#" className="back">
                  Back To Home
                </Link>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Login;
